
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 13","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('text',{staticStyle:{"line-height":"24px"},attrs:{"dominant-baseline":"text-before-edge","font-family":"'FontAwesome5Pro-Solid','FontAwesome5Pro-Solid'","font-size":"25.41","font-style":"none","font-weight":"400"}},[_c('tspan',{staticStyle:{"font-kerning":"normal"}},[_v('shipping-fast')])])])
          )
        }
      }
    